import { connect } from 'react-redux'

import { togglePanel } from '../../../../../common/actions/layout'
import { hasFeature } from '../../../../../common/utils/features'
import FilterPanel from './'

const mapStateToProps = (state, ownProps) => {
  const {
    layout: { toggledPanelIds },
    common: { currentSite },
    router: { location },
    experiments
  } = state

  const shouldCollapseFilters = hasFeature(
    'filters:collapsed',
    currentSite,
    location,
    experiments
  )

  const filterSelected = toggledPanelIds.indexOf(ownProps.id) < 0
  const expanded = shouldCollapseFilters ? !filterSelected : filterSelected

  return { expanded }
}

const mapDispatchToProps = dispatch => {
  return {
    togglePanel: panelId => {
      dispatch(togglePanel(panelId))
    }
  }
}

const PanelContainer = connect(mapStateToProps, mapDispatchToProps)(FilterPanel)

export default PanelContainer
